module.exports = __webpack_public_path__ + "static/media/class (2).77fb78e0.webp";